/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Use_Product_Other_Devices_HeadingInputs */

const en_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Use ${i?.displayName} on other devices`)
};

const id_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gunakan ${i?.displayName} di perangkat lain`)
};

const ms_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gunakan ${i?.displayName} di peranti lain`)
};

const ca_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Utilitzar ${i?.displayName} en altres dispositius`)
};

const cs_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Používejte ${i?.displayName} i na ostatních zařízeních`)
};

const da_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Brug ${i?.displayName} på andre enheder`)
};

const de_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} auf anderen Geräten verwenden`)
};

const et_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teenuse ${i?.displayName} kasutamine teistes seadmetes`)
};

const es_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usa ${i?.displayName} en otros dispositivos`)
};

const fr_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Utilisez ${i?.displayName} sur d’autres appareils.`)
};

const hr_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Koristite ${i?.displayName} na drugim uređajima`)
};

const it_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usa ${i?.displayName} su altri dispositivi`)
};

const lv_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lietojiet ${i?.displayName} citās ierīcēs`)
};

const lt_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Naudoti ${i?.displayName} kituose įrenginiuose`)
};

const hu_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A ${i?.displayName} használata más eszközökön`)
};

const nl_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} gebruiken op andere apparaten`)
};

const nb_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bruk ${i?.displayName} på andre enheter`)
};

const pl_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Używaj ${i?.displayName} na innych urządzeniach`)
};

const pt_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Use o ${i?.displayName} em outros dispositivos`)
};

const ro_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Utilizează ${i?.displayName} pe alte dispozitive`)
};

const sk_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Používanie ${i?.displayName} na iných zariadeniach`)
};

const sl_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uporabite »${i?.displayName}« v drugih napravah`)
};

const fi_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Käytä kohdetta ${i?.displayName} muissa laitteissa`)
};

const sv_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Använda ${i?.displayName} på andra enheter`)
};

const vi_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sử dụng ${i?.displayName} trên các thiết bị khác`)
};

const tr_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} hesabını diğer cihazlarda kullanın`)
};

const el_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Χρήση του ${i?.displayName} σε άλλες συσκευές`)
};

const bg_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Използване на ${i?.displayName} на други устройства`)
};

const ru_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Используйте ${i?.displayName} на других устройствах`)
};

const sr_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Користите функцију ${i?.displayName} на другим уређајима`)
};

const uk_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Використовуйте ${i?.displayName} на інших пристроях`)
};

const ka_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`გამოიყენეთ ${i?.displayName} სხვა მოწყობილობებზე`)
};

const hi_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} दुसरे डिवाईसेस पर इस्तेमाल करें`)
};

const th_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ใช้ ${i?.displayName} บนอุปกรณ์อื่น`)
};

const ko_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`다른 기기에서 ${i?.displayName} 사용`)
};

const zh_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`在其他设备上使用 ${i?.displayName}`)
};

const zh_tw_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`在其他裝置上使用 ${i?.displayName}`)
};

const ja_use_product_other_devices_heading = /** @type {(inputs: Use_Product_Other_Devices_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} を他のデバイスで使用する`)
};

/**
* | output |
* | --- |
* | "Use {displayName} on other devices" |
*
* @param {Use_Product_Other_Devices_HeadingInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const use_product_other_devices_heading = /** @type {((inputs: Use_Product_Other_Devices_HeadingInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Use_Product_Other_Devices_HeadingInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_use_product_other_devices_heading(inputs)
	if (locale === "ms") return ms_use_product_other_devices_heading(inputs)
	if (locale === "ca") return ca_use_product_other_devices_heading(inputs)
	if (locale === "cs") return cs_use_product_other_devices_heading(inputs)
	if (locale === "da") return da_use_product_other_devices_heading(inputs)
	if (locale === "de") return de_use_product_other_devices_heading(inputs)
	if (locale === "et") return et_use_product_other_devices_heading(inputs)
	if (locale === "es") return es_use_product_other_devices_heading(inputs)
	if (locale === "fr") return fr_use_product_other_devices_heading(inputs)
	if (locale === "hr") return hr_use_product_other_devices_heading(inputs)
	if (locale === "it") return it_use_product_other_devices_heading(inputs)
	if (locale === "lv") return lv_use_product_other_devices_heading(inputs)
	if (locale === "lt") return lt_use_product_other_devices_heading(inputs)
	if (locale === "hu") return hu_use_product_other_devices_heading(inputs)
	if (locale === "nl") return nl_use_product_other_devices_heading(inputs)
	if (locale === "nb") return nb_use_product_other_devices_heading(inputs)
	if (locale === "pl") return pl_use_product_other_devices_heading(inputs)
	if (locale === "pt") return pt_use_product_other_devices_heading(inputs)
	if (locale === "ro") return ro_use_product_other_devices_heading(inputs)
	if (locale === "sk") return sk_use_product_other_devices_heading(inputs)
	if (locale === "sl") return sl_use_product_other_devices_heading(inputs)
	if (locale === "fi") return fi_use_product_other_devices_heading(inputs)
	if (locale === "sv") return sv_use_product_other_devices_heading(inputs)
	if (locale === "vi") return vi_use_product_other_devices_heading(inputs)
	if (locale === "tr") return tr_use_product_other_devices_heading(inputs)
	if (locale === "el") return el_use_product_other_devices_heading(inputs)
	if (locale === "bg") return bg_use_product_other_devices_heading(inputs)
	if (locale === "ru") return ru_use_product_other_devices_heading(inputs)
	if (locale === "sr") return sr_use_product_other_devices_heading(inputs)
	if (locale === "uk") return uk_use_product_other_devices_heading(inputs)
	if (locale === "ka") return ka_use_product_other_devices_heading(inputs)
	if (locale === "hi") return hi_use_product_other_devices_heading(inputs)
	if (locale === "th") return th_use_product_other_devices_heading(inputs)
	if (locale === "ko") return ko_use_product_other_devices_heading(inputs)
	if (locale === "zh") return zh_use_product_other_devices_heading(inputs)
	if (locale === "zh-tw") return zh_tw_use_product_other_devices_heading(inputs)
	if (locale === "ja") return ja_use_product_other_devices_heading(inputs)
	return en_use_product_other_devices_heading(inputs)
});